import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from '@chakra-ui/react';
import { companyParams } from '../assets/company';
import { useRecoilState } from 'recoil';
import {
  companyInfoState,
  companyNameState,
  isDevState,
} from '../lib/atoms/companyState';
import usePathNavigate from '../lib/hook/usePathNavigate';
import { Helmet } from 'react-helmet-async';

function Root() {
  const { pathNavigate, backNavigate } = usePathNavigate();

  const [loaded, setLoaded] = useState(false);
  const [companyList, setCompanyList] = useRecoilState(companyInfoState);
  const [companyName, setCompanyName] = useRecoilState(companyNameState);
  // dev: dev-
  const [isDev, setIsDev] = useRecoilState(isDevState);

  const getCompanyName = () => {
    let company_name = 'shoemaster';
    if (window.location.origin.includes('dev-')) {
      company_name = window.location.origin
        .split('https://')[1]
        .split('.')[0]
        .replace('dev-', '');
    } else if (window.location.origin.includes('test-')) {
      company_name = window.location.origin
        .split('https://')[1]
        .split('.')[0]
        .replace('test-', '');
    } else if (window.location.origin.includes('https://')) {
      company_name = window.location.origin.split('https://')[1].split('.')[0];
    }
    return company_name;
  };

  async function preLoad() {
    const company_name = getCompanyName();
    setCompanyName(company_name);

    // dev: dev-
    const oem_comapny = isDev
      ? 'dev-offline_oem_company'
      : 'offline_oem_company';
    const response = await fetch(
      `https://mintwk.edge.naverncp.com/mint-house/${oem_comapny}.json`,
      {
        cache: 'no-cache',
        mode: 'cors',
        // credentials: 'include',
        // headers: {
        //   'access-control-allow-origin': '*',
        //   'Content-type': 'application/json; charset=UTF-8',
        // },
      },
    );
    const info: companyParams = await response.json();
    setCompanyList(info);

    if (info !== undefined) {
      setLoaded(true);
      if (info[company_name].intropopup === 'true') {
        const isViewIntro = localStorage.getItem('isViewIntro');
        if (isViewIntro === 'false' || isViewIntro === null)
          pathNavigate('/intro');
      }
    }
    // console.log(info);
  }

  // dev: dev-[companyName]
  // live: [companyName]
  useEffect(() => {
    preLoad();
  }, []);

  return (
    <Container
      maxW={'768px'}
      minW={'320px'}
      w={'100%'}
      height={'100vh'}
      px={0}
      bg={'white'}>
      {companyName !== '' && companyList[companyName] !== undefined && (
        <Helmet>
          <title>{companyList[companyName]?.favtitle}</title>
          <link rel="icon" href={companyList[companyName]?.favicon} />
        </Helmet>
      )}

      {loaded && <Outlet />}
    </Container>
  );
}

export default Root;
